import Entity from '../entity'

export default class UserProfile extends Entity<number>{
    userId: string  = null;
    userNo: string  = null;
    avatarImageUrl: string  = null;
    gender: string  = null;
    identificationCardNo: string  = null;
    tenantId: number  = null;
    beganWorkDay: Date  = null;
    birthday: Date  = null;
    remark: string  = null;
    fullName: string  = null;
}